import { gql } from '@apollo/client'

export const CUSTOMERS_DUPLICATES_QUERY = gql`
  query customersDuplicatesQuery($id: ID!) {
    duplicateCustomers(id: $id) {
      id
      firstname
      lastname
      policyNumber
      mobileNumber
      phoneNumber
      street
      houseNumber
      email
      duplicateEmail
      possibleDuplicate
      cases {
        id
        claimNumber
      }
    }
  }
`
